import { createFileRoute } from "@tanstack/react-router";
import { AppSettingsView } from "@/features/app-settings";

export const Route = createFileRoute("/app-settings")({
  component: AppSettingsView,
});
